export { UniPageProcessHero } from "./hero";
